


























import { Component, Prop, Vue } from "vue-property-decorator";

@Component({})
export default class CustomInput extends Vue 
{
    @Prop({ default: 1 }) step!: number;
    @Prop() value! : number;
    @Prop({ default: "" }) unit! : string;
    @Prop({ default: "" }) prefix! : string;
    @Prop({ default: false }) isUnitBefore! : boolean;
    @Prop({ default: "" }) plusMinus! : string;
    @Prop() digits! : number;
    @Prop({ default: false }) isBlank! : boolean;

    private isInput = false;

    // focus中フラグ *firefoxで.focus()を呼ぶとblurが呼ばれるので短時間これを防ぐ
    private isFocusing = false;

    // TextEditorのfocusLockを解除する
    private unlockTextEditorFocus()
    {
        // メッセージセンター取得
        var messageCenter = this.$store.getters.messageCenter;
        // メッセージセンターに送信
        messageCenter.send("unlock_text_editor_focus", null);
    }

    private changeInputMode(mode)
    {
        this.$store.dispatch("changeInputMode", mode);
    }

    private get fixValue()
    {
        // X.XX に補正
        var powFactor = Math.pow(10, Number(this.digits));
        var fix = Math.round(Number(this.value) * powFactor) / powFactor;
        return fix;
    }

    private get valueText()
    {
        if(this.isBlank)
        {
            return "";
        }
        else if(this.prefix != "")
        {
            return this.prefix + this.plusMinus + this.fixValue.toFixed(Number(this.digits)) + this.unit;
        }
        else if(this.isUnitBefore)
        {
            return this.unit + this.plusMinus + this.fixValue.toFixed(Number(this.digits));
        }
        else
        {
            return this.plusMinus + this.fixValue.toFixed(Number(this.digits)) + this.unit;
        }
    }

    private onClick()
    {
        this.isInput = true;
        this.$nextTick(function()
        {
            var input = this.$refs.input as HTMLInputElement;
            if(input)
            {
                this.isFocusing = true;
                input.select();
                input.focus();
                this.$nextTick(function()
                {
                    this.isFocusing = false;
                });
            }
        });

        // クリックイベント
        this.$emit("clicked");
    }

    private onFocus()
    {
        this.changeInputMode(1);
    }

    private onBlur(value)
    {
        if(this.isFocusing) { return; }
        this.changeInputMode(0);
        
        this.isInput = false;
        this.$emit("setValue", Number(value));
    }

    moveNext(event, isShiftKeyDown)
    {
        if(this.isFocusing) { return; }

        this.onBlur(event.target.value);
        this.$emit("tabKeyDown", event, isShiftKeyDown);
    }

    private get userConfigTextAColorStyle(){
        var style = {
            color : this.$store.getters.userConfigColors.textAColor
        };
        return style;
    }
}
